<template>
  <section id="about">
    <div class="hero-image">
      <img src="../../static/static-css/img/about-us/about.jpg" alt />
      <div class="overlay"></div>
    </div>
    <div class="dasboard-content">
      <div class="container">
        <div class="row">
          <div class="col-12">

            <div class="tittle">
              <h3>Cookie Policy</h3>
            </div>
            <div class="content">
              <h5 class="content-heading">1) Cookies and similar technologies</h5>
              <p>
                A cookie is a small text file which is placed onto your computer or electronic device when you access our website. Similar technologies include web beacons, action tags, local shared objects ('flash cookies') and single-pixel gifs. Such technologies can be used to track users' actions and activities, and to store information about them. We use these cookies and/or similar technologies on this website for the following purposes:
              </p>
              <ul>
                <li>
                  <p class="mb-0">To improve user experience while the user navigates through the website</P>
                </li>
                <li><p class="mb-0">To identify the most popular sections of our website</P></li>
                <li><p class="mb-0">To anlayze and understand how users use the website</P></li>
                <li><p class="mb-0">To obtain information about users’ preferences</P></li>
              </ul>
            </div>
            <div class="content">
              <h5 class="content-heading">2) Information collected</h5>
              <p>
                We may obtain information about your computer or any other electronic device which you use to access our website, such as your IP address, your browser and/or other internet log information. We will treat this information as your personal information.
              </p>
              <p>In certain circumstances we may also collect personal information about you but only where you voluntarily provide it (e.g by completing an online form) or where you purchase goods or services from us.</p>
            </div>
            <div class="content">
              <h5 class="content-heading">3) Consent for cookies</h5>
              <p>
                In most cases we will need your consent in order to use cookies on this website. The exception is where the cookie is essential in order for us to provide you with a service you have requested, or essential to the inherent functionality of the website (e.g to enable you to store items in a shopping basket and/or to use our check-out process).
              </p>
            </div>
            <div class="content">
              <h5 class="content-heading">4) Third-party cookies</h5>
              <p>
                We work with third party suppliers who may also set cookies on our website. These cookies and their third party owners, are included in the table below. By consenting to the use of cookies on our site you will be consenting to the use of these cookies. These cookies may be used to collect the following information:
              </p>
              <p>The fact that you visted our website; time of visit; and your IP address.</p>
            </div>
            <div class="content">
              <h5 class="content-heading">5) Cookies and similar technologies used on this website</h5>
              <p>
                The following cookies/similar technologies are used on this website:
                We may use pixels, or transparent GIF files, to help manage online advertising. These files enable us to recognize a unique cookie, placed by us, on your web browser, which in turn enables us to learn which advertisements bring users to our website.
              </p>
            </div>
            <div class="content">
              <h5 class="content-heading">6) How to turn off cookies</h5>
              <p>
                You can set your browser not to accept cookies and the websites below tell you how to remove cookies from your browser. However, some of our website features may not function as a result.
              </p>
              <p>For further information on cookies generally visit aboutcookies.org</p>
            </div>

          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  created () {
    this.$store.commit('ISLOADING', false)
  }
}
</script>

<style>

.hero-image {
  position: relative;
}
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
  background-color: rgba(0,0,0,0.5);
}

.hero-image img {
  max-height: 500px;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/cookie.vue